import * as React from "react";
import { List, Datagrid, TextField, TextInput, Show, SimpleShowLayout, Filter } from 'react-admin';
import { MyPagination } from './pagination';


const EmployeeFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
    </Filter>
);

export const EmployeeList = (props) => (
    <List {...props} title='Сотрудники' filters={<EmployeeFilter />} pagination={<MyPagination/>}>
        <Datagrid rowClick="show">
            <TextField source="id" label="ID" sortable={false} />
            <TextField source="name" label="Имя" sortable={false} />
            <TextField source="position" label="Должность" sortable={false} />
            <TextField source="dep" label="Департамент" sortable={false} />
            <TextField source="manager" label="Менеджер" sortable={false} />
            <TextField source="manager_regional" label="Региональный менеджер" sortable={false} />
        </Datagrid>
    </List>
);

export const EmployeeShow = (props) => (
    <Show {...props} title='Сотрудник'>
        <SimpleShowLayout>
        <TextField source="id" label="ID" sortable={false} />
            <TextField source="name" label="Имя" sortable={false} />
            <TextField source="position" label="Должность" sortable={false} />
            <TextField source="dep_id" label="ИД Департамента" sortable={false} />
            <TextField source="dep" label="Департамент" sortable={false} />
            <TextField source="manager_id" label="ИД Менеджера" sortable={false} />
            <TextField source="manager" label="Менеджер" sortable={false} />
            <TextField source="manager_regional_id" label="ИД Регионального менеджера" sortable={false} />
            <TextField source="manager_regional" label="Региональный менеджер" sortable={false} />
        </SimpleShowLayout>
    </Show>
);
